import React from "react";
import { isMobile } from "react-device-detect";
import { observer } from "mobx-react-lite";

import {
  TableFilterContainer,
  TableFilterDivider,
  TableFilterSection,
} from "framework/components/table/TableFilter";
import TextInput from "framework/components/form/TextInput";
import TagsFilterSection from "pages/app/DocumentsOverviewPage/TagsFilterSection";
import { Tag as TagDb } from "thunk-core";

type Props = {
  search: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  selectedTags: TagDb[];
  setSelectedTitles: React.Dispatch<React.SetStateAction<string[]>>;
};

const DocumentsFilter = observer((props: Props) => {
  const { search, setSearch, setSelectedTitles, selectedTags } = props;

  return (
    <TableFilterContainer>
      <TableFilterSection>
        <TextInput
          name="search"
          autoFocus={!isMobile}
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </TableFilterSection>

      <TableFilterDivider />

      <TagsFilterSection
        selectedTags={selectedTags}
        setSelectedTitles={setSelectedTitles}
      />
    </TableFilterContainer>
  );
});

export default DocumentsFilter;
